module.exports = {"menu":{"drawingSystem":"Drawing System","drawingSystem2":"Drawing System New","about":"About","master":"Master Data","sellOrder":"Request Drawing","user":"Users","settings":"Settings","systemSettings":"System","transferTitle":"Transfer","userTitle":"User","systemInfo":"System Info","titleSinglePD":"Change Raw Mat","titleMultiPD":"Multi PD","titleRmSummary":"Rm Summary"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/menu.json
// module id = 548
// module chunks = 35